const ShimmerSection = ({ rows = 6 }: { rows?: number }) => (
  <div className="bg-white border border-gray-200 rounded-xl shadow-sm p-4 mb-6">
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {Array.from({ length: rows }).map((_, idx) => (
        <div key={idx}>
          <div className="bg-gray-200 rounded w-1/3 h-4 mb-1 animate-pulse" />
          <div className="bg-gray-300 rounded w-2/3 h-5 animate-pulse" />
        </div>
      ))}
    </div>
  </div>
)

const LeftSplitShimmer = () => {
  return (
    <div className="p-4 w-full  mt-3 rounded mx-auto border h-full">
      <div className="flex space-x-4 mb-4">
        <div className="bg-gray-300 rounded w-24 h-7 animate-pulse" />
        <div className="bg-gray-300 rounded w-20 h-7 animate-pulse" />
        <div className="bg-gray-300 rounded w-28 h-7 animate-pulse" />
      </div>

      <ShimmerSection rows={8} />
      <ShimmerSection rows={5} />
      <ShimmerSection rows={9} />
      <ShimmerSection rows={5} />
    </div>
  )
}

export default LeftSplitShimmer
